<script setup lang="ts">
import { computed, type InputHTMLAttributes } from "vue";
import { htmlAttrs } from "../../lib/utils";
import Input, { type InputProps } from "./Input.vue";

interface Props
	extends InputProps,
		/* @vue-ignore */ Omit<InputHTMLAttributes, keyof InputProps | "type"> {
	emptyAsNull?: boolean;
}

const props = defineProps<Props>();

const model = defineModel<number | null | undefined>();

const localValue = computed({
	get() {
		return model.value;
	},
	set(val: number | null | undefined | "") {
		if (props.emptyAsNull && val === "") {
			val = null;
		}

		model.value = val as any;
	},
});
</script>

<template>
	<Input v-model="localValue" type="number" v-bind="{ ...props, ...htmlAttrs($attrs) }" />
</template>
